import { render } from "./AddOriginModal.vue?vue&type=template&id=33814b62&scoped=true"
import script from "./AddOriginModal.vue?vue&type=script&lang=js"
export * from "./AddOriginModal.vue?vue&type=script&lang=js"

import "./AddOriginModal.vue?vue&type=style&index=0&id=33814b62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33814b62"],['__file',"src/components/modals/AddOriginModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33814b62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33814b62', __exports__)) {
    api.reload('33814b62', __exports__)
  }
  
  module.hot.accept("./AddOriginModal.vue?vue&type=template&id=33814b62&scoped=true", () => {
    api.rerender('33814b62', render)
  })

}


export default __exports__